module.exports = __webpack_public_path__ + "img/detail.382283e6.jpg";